const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const aiSearchSchema = z.object({
  mode: z.string().optional().catch(undefined)
});

/**
 * Unified panel: /ai no longer renders a page, it hands off to the conversation
 * panel via the global URL params.
 *
 * The sign-up onboarding auto-start stays here rather than moving to the entry
 * hook: it depends on being on an AI route, which stops being true the moment
 * we redirect, and this component is what shows the loader while the
 * conversation is created. Creation is idempotent, so re-entry is safe.
 */

export const Route = createFileRoute("/_protected/ai/")({
  validateSearch: aiSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    shellMode: "canvas-only"
  }
});